import React from 'react';
import { Award, Globe2, Users2, BookOpen, Trophy, Target } from 'lucide-react';

const features = [
  { icon: Trophy, title: 'Industry Leadership', description: 'The top professional export management school in Nigeria and West Africa.' },
  { icon: Globe2, title: 'Global Recognition', description: 'Certifications and curricula benchmarked against international trade standards.' },
  { icon: Users2, title: 'Expert Instructors', description: 'Faculty made up of seasoned exporters, freight forwarders, and trade advisors.' },
  { icon: BookOpen, title: 'Comprehensive Curriculum', description: 'End-to-end coverage of documentation, logistics, finance, and market entry.' },
  { icon: Target, title: 'Practical Approach', description: 'Live case studies, real buyer negotiations, and market-scenario simulations.' },
  { icon: Award, title: 'Proven Track Record', description: 'A 4,000+ alumni network shipping to more than twenty countries today.' },
];

const WhyChooseLSEM = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-sm font-medium mb-5">
            Why LSEM
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            The reasons exporters choose us — again and again
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-2xl border border-gray-200 bg-white p-7 hover:border-blue-300 hover:shadow-lg transition-all"
            >
              <div className="w-11 h-11 rounded-lg bg-blue-50 flex items-center justify-center mb-5 group-hover:bg-blue-600 transition-colors">
                <f.icon className="h-5 w-5 text-blue-600 group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseLSEM;